// extracted by mini-css-extract-plugin
export default {"formContainer":"RoleForm_formContainer__18kxO","switcher":"RoleForm_switcher__hGtUq","alertFixed":"RoleForm_alertFixed__+5jI-"};